import React from 'react'
import { Box, Modal } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import { useStyles } from 'styles/material-styles/loader'
import { LoaderInterface } from 'ts/interfaces/loaderProps.interface'

const Loader = ({ open }: LoaderInterface) => {
  const { classes } = useStyles()

  return (
    <Modal open={open}>
      <Box className={classes.container}>
        <CircularProgress size={60} />
      </Box>
    </Modal>
  )
}

export default Loader
